<template>
  <div class="apply-free-bill">

    <div class="table-bd">
      <custom-table
        height="300px"
        :data="tableList"
        :column="tableColumn"
        :tableCode="tableCode"
        @sort="sortChange"
        @filter="filterChange"
        :slots="['freeDays', 'action', 'termNum']"
        :filterArr="model.type === 'watch' ? ['action'] : []"
      >
        <template v-slot:termNum="scope">{{scope.row.termNum}}/{{scope.row.totalTerm}}</template>
        <template v-slot:freeDays="scope">{{ scope.row.freeDuration || '0' }}{{ getDicValue('crm_sharing_rule_free_unit', scope.row.freeUnit) }}</template>
        <template v-slot:action="scope">
          <el-button
            type="text"
            size="mini"
            @click="onDel(scope.$index)"
          >{{ $t('Common.com_delete') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="params">
      <div
        class="item"
        v-if="isPay"
      >
        <div class="key">{{ $t('components_apply_free.shou_kuan_fang') }}：</div>
        <div class="val">{{firstItem.receivableOrgName}}</div>
      </div>
      <div
        class="item"
        v-else
      >
        <div class="key">{{ $t('components_apply_free.fu_kuan_fang') }}：</div>
        <div class="val">{{firstItem.payableOrgName}}</div>
      </div>
      <div class="item">
        <div class="key">{{ $t('components_apply_free.mian_shou_he_ji') }}：</div>
        <div class="val">￥{{total}}</div>
      </div>
    </div>
    <el-form
      label-position="top"
      :inline="true"
      ref="form"
      style="margin-top: 15px;"
      :model="form"
      :rules="rules"
    >
      <el-form-item
        :label="$t('components_apply_free.shen_qing_yuan_yin')"
        prop="changeDesc"
        style="width: 100%"
      >
        <el-input
          v-model="form.changeDesc"
          type="textarea"
          :disabled="model.type === 'watch'"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
/** 申请免收 */

import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    model: {
      type: Object,
      default() {
        return {
          row: [],
          type: '', // edit watch
          changeType: '',
        };
      },
    },
  },
  data() {
    return {
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
        billTradeState: 0,
      },
      totalRows: null,
      form: {
        changeDesc: '',
        changeId: '',
      },
      info: {
        billViewList: [],
      }
    };
  },
  computed: {
    rules() {
      return {
        changeDesc: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
    total() {
      const list = this.info && this.info.billViewList ? this.info.billViewList : [];
      const key = 'paymentAmount';
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    changeId() {
      return this.model.changeId;
      //  return '541982994487300096';
    },
    tableList() {
      return this.info.billViewList || [];
    },
    changeType() {
      return this.model.changeType;
    },
    isPay() {
      const list = this.info && this.info.billViewList ? this.info.billViewList : [];
      const userInfo = this.$store.state.userInfo;
      if (list.length && userInfo) {
        const firstItem = list[0];
        const { payableOrgId } = firstItem;
        return userInfo.rootOrgId === payableOrgId;
      }
      return false;
    },
    firstItem() {
      const list = this.info && this.info.billViewList ? this.info.billViewList : [];
      if (list.length) {
        return list[0];
      }
      return {};
    },
    tableCode() {
      // const type = this.model.changeType || 'free_stock_fee';

      // const map = {
      //   'free_stock_fee': 'apply_free_stock',
      //   'free_overdue_fee': 'apply_late_fee',
      //   // 逾期费 和 违约费公用一个tableCode
      //   'free_break_fee': 'apply_late_fee'
      // };

      // return map[type];
      // 现在统一了申请免收
      return 'apply_free_bill';
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    getInfo() {
      if (this.changeId) {
        const path = this.getInfoReqUrl(this.changeType);
        this.$getJSON(`${path}/${this.changeId}`).then((res) => {
          this.info = res.data;
          this.form.changeDesc = res.data.changeDesc;
          this.form.changeId = this.changeId;
        });
      } else {
        this.info = {
          billViewList: [...this.model.row]
        };
      }
    },
    getInfoReqUrl(type) {
      if (type === 'free_stock_fee') {
        return apis.fmsChangeStockInfo;
      } else if (type === 'free_overdue_fee') {
        return apis.billOrderOverdueFreeInfo;
      } else if (type === 'free_test_fee') {
        return apis.billOrderTestFreeInfo;
      }
      return apis.billBreakFreeInfo;
    },
    onDel(index) {
      this.info.billViewList.splice(index, 1);
    },
    // 获取表格数据
    getTableList: function () { },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    closeDialog() {
      this.visible = false;
    },
    // 草稿
    onDraft() {
      // if (!this.changeId) {
      //   this.$message.error('请先保存');
      //   return;
      // }
      if (!this.tableList.length) {
        this.$message.error(this.$t('components_apply_free.lbbnwk'));
        return;
      }
      if (this.model.changeId) {
        if (!this.form.changeDesc) {
          this.$message.error(this.$t('components_apply_free.sqyybnwk'));
          return;
        }
      }
      const reqData = this.getReqData('draft');
      const reqUrl = this.getSubmitReqUrl(this.changeType);
      this.$postJSON(reqUrl, reqData, true)
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.$emit('success');
        })
        .then((res) => {
          this.form.changeId = res.data;
        });
    },

    getSubmitTitle() {
      const type = this.changeType;
      const map = {
        free_stock_fee: this.$t('components_apply_free.mskcglf'),
        free_overdue_fee: this.$t('components_apply_free.mian_shou_yu_qi_fei'),
        free_break_fee: this.$t('components_apply_free.mswyj'),
      };
      return map[type];
    },
    // 提交
    onSubmit() {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      if (!this.tableList.length) {
        this.$message.error(this.$t('components_apply_free.lbbnwk'));
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          const reqData = this.getReqData('draft');
          const type = this.changeType;
          const url = this.getSubmitReqUrl(type);
          this.$postJSON(url, reqData, true)
            .then((res) => {
              this.form.changeId = res.data;
              const submitData = this.getReqData('submit');
              this.$postJSON(`${apis.apsApproveApprovalApproveStart}/${type}/${this.form.changeId}`, submitData, true).then(() => {
                this.$message({
                  type: 'success',
                  message: this.$t('Common.com_handle_success'),
                });
                this.$emit('success');
              });
            });
        }
      });
    },
    getSubmitReqUrl(type) {
      if (type === 'free_stock_fee') {
        // 库存管理费 （新增编辑都是这个接口）
        return apis.fmsChangeStockAdd;
      }
      if (type === 'free_overdue_fee') {
        // 逾期费
        return this.model.changeId ? apis.billOrderOverdueFreeUpdate : apis.billOrderOverdueFreeAdd;
      }
      if (type === 'free_test_fee') {
        // 试用账单
        return this.model.changeId ? apis.billOrderTestFreeUpdate : apis.billOrderTestFreeAdd;
      }

      return this.model.changeId ? apis.billBreakFreeUpdate : apis.billBreakFreeAdd;
    },
    getReqData(type = 'draft') {
      if (type === 'draft') {
        const ret = {
          ...this.form,
          changeBillList: this.tableList.map(item => ({
            billId: item.billId,
          })),
        };
        return ret;
      } else {
        const title = this.getSubmitTitle();
        const applyReason = this.form.changeDesc;
        return {
          title,
          applyReason,
        };
      }
    },
    onConfirm(isSubmit) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      if (isSubmit) {
        this.onSubmit();
      } else {
        this.onDraft();
      }
    },
  },
  created() { },
  mounted() {
    this.getInfo();
  },
};
</script>

<style lang="scss">
.apply-free-bill {
  .params {
    margin-top: 15px;
    .item {
      overflow: hidden;
      line-height: 24px;
      color: #495057;
      font-weight: bold;
      font-size: 12px;
      .key {
        float: left;
      }
      .val {
        float: left;
      }
    }
  }
}
</style>
